import type {ReactElement} from 'react';
import React, { useEffect, useState} from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {DropdownDefaultSelectBox} from '@Components/dropdown-v2/components/dropdown-default-select-box';
import {FontSelectorPanel} from '@Components/font-selector-panel';
import {DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import type { FontData} from '@Libraries/font-library';
import {addFonts, getAllFontsMap, initFonts} from '@Libraries/font-library';
import {useAppSelector} from '@/hooks';

export function TextMaskingDropdownOption(): ReactElement {
  const areFontsLoading = useAppSelector((state) => {
    return state.fontSelector.areFontsLoading;
  });
  const maskingFontFamily = useAppSelector((state) => {
    return state.textMasking.maskedTextProps.fontFamily;
  });
  const [isFontLoading, setIsFontLoading] = useState(false);

  useEffect(() => {
    initFonts().catch(() => {
      window.PMW.openErrorModal({
        message: window.i18next.t('pmwjs_error_message'),
      });
    });
  }, []);

  const getFontName = (): string => {
    if (areFontsLoading) {
      return window.i18next.t('pmwjs_loading');
    }
    const allFontsMap = getAllFontsMap() as Record<string, FontData>;
    if (!maskingFontFamily) {
      throw new Error('unable to find font name from font family');
    }
    return allFontsMap[maskingFontFamily].name;
  };

  const getSelector = (): ReactElement => {
    return <DropdownDefaultSelectBox text={getFontName()} isLoading={areFontsLoading || isFontLoading} />;
  };

  const onSelectFontFamily = (font: FontData): void => {
    setIsFontLoading(true);
    addFonts([font.fontFamily], (): void => {
      window.textMask?.setFontFamily(font.fontFamily);
      setIsFontLoading(false);
    });
  };

  const getPopup = (): ReactElement => {
    return <FontSelectorPanel selectedFontFamily={maskingFontFamily} onSelectFontFamily={onSelectFontFamily} showUserFonts={false} showDropdownVariant className="spacing-p-0" />;
  };

  return <Dropdown position={DROPDOWN_POSITION.FIXED} selector={getSelector()} popup={getPopup()} />;
}
